import React, { memo } from 'react'

import {
  arrayOf, func, node, number, shape, string,
} from 'prop-types'

import ExpandedImage from '../ExpandedImage/ExpandedImage'

// Masonry gallery of reference images: a fixed number of columns per breakpoint
// with images stacked one after another at their native aspect ratio (Pinterest
// style). Selecting an image replaces the gallery with a full-height detail
// preview.
function ImageGrid({
  images, selectedImage = null, header = null, onSelectImage, onClose, onApply, onModify, onEdit,
}) {
  if (selectedImage) {
    return (
      <div className="image-assistant-search-tab__section image-assistant-search-tab__section--preview">
        {header}
        <ExpandedImage
          image={selectedImage}
          onClose={onClose}
          onApply={onApply}
          onModify={onModify}
          onEdit={onEdit}
        />
      </div>
    )
  }

  return (
    <div className="image-assistant-search-tab__section">
      {header}
      <div className="image-assistant-search-tab__masonry">
        {images.map(image => (
          <button
            key={image.id}
            type="button"
            className="image-assistant-search-tab__card image-assistant-search-tab__card--image"
            onClick={() => onSelectImage(image)}
          >
            <img
              className="image-assistant-search-tab__card-image"
              src={image.url}
              alt={image.alt}
              loading="lazy"
              decoding="async"
            />
          </button>
        ))}
      </div>
    </div>
  )
}

ImageGrid.propTypes = {
  images: arrayOf(shape({
    id: number.isRequired,
    url: string.isRequired,
    alt: string,
  })).isRequired,
  selectedImage: shape({ id: number }),
  header: node,
  onSelectImage: func.isRequired,
  onClose: func.isRequired,
  onApply: func.isRequired,
  onModify: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(ImageGrid)
